export const LOGIN_PAGE_URL = '/login';
export const REGISTER_PAGE_URL = '/register';

export const USERS_PAGE_URL = '/users';
export const USERS_ME_PAGE_URL = '/users/me';
export const USERS_EDIT_PAGE_URL = '/users/edit';
export const USERS_WISH_PAGE_URL = '/users/wish';

export const END_GAMES_PAGE_URL = '/end-games';
export const END_GAMES_REVIEWS_CREATE_PAGE_URL = '/end-games/reviews/create';

export const BOARD_GAMES_PAGE_URL = '/board-games';
export const BOARD_GAMES_TIP_CREATE_PAGE_URL = '/board-games/tip/create';

export const GATHERINGS_PAGE_URL = '/gatherings';
export const GATHERINGS_CREATE_PAGE_URL = '/gatherings/create';
export const GATHERINGS_FIX_PAGE_URL = '/gatherings/fix';
export const GATHERINGS_UNFIX_PAGE_URL = '/gatherings/unfix';

export const CHATS_PAGE_URL = '/chats';

export const NOTIFICATIONS_PAGE_URL = '/notifications';
